/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityFindingNativeDetailsBaseForContainer extends models.SecurityFindingNativeDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("SecurityFindingNativeDetailsBaseForContainer");
    }

    getFixupPrototypeFunction() { return SecurityFindingNativeDetailsBaseForContainer.fixupPrototype; }

    static newInstance(model: Partial<SecurityFindingNativeDetailsBaseForContainer>): SecurityFindingNativeDetailsBaseForContainer {
        let obj = Object.assign(new SecurityFindingNativeDetailsBaseForContainer(), model);
        SecurityFindingNativeDetailsBaseForContainer.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityFindingNativeDetailsBaseForContainer>): SecurityFindingNativeDetailsBaseForContainer {
        if (!model) return null;
        return SecurityFindingNativeDetailsBaseForContainer.newInstance(<SecurityFindingNativeDetailsBaseForContainer> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityFindingNativeDetailsBaseForContainer) {
        if (!obj) return;

        models.SecurityFindingNativeDetailsBaseForContainer.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityFindingNativeDetailsBaseForContainer): boolean {
        if (models.SecurityFindingNativeDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SecurityFindingNativeDetailsBaseForContainer.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.detected_at === "string") {
            this.detected_at = new Date(<string><any>this.detected_at);
        }
    }

    /**
     * Unique identifier of the SBOM version associated with the container or Dockerfile that was scanned
     */
    sbom_version_id: string;

    /**
     * Unique rule identifier code for the specific security check that detected this finding
     */
    code: string;

    /**
     * Timestamp indicating when the security finding was first detected by the scanning tool
     */
    detected_at: Date;

}
